<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item>
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.name"
        placeholder="发布主体名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
export default {
  name: "search",
  components: {
    butn
  },
  data() {
    return {
      filters: {}
    };
  },
  created() {},
  methods: {
    initData() {
      //查询
      this.$emit("search", this.filters);
    },
    resetData() {
      //重置
      this.filters = {};
      this.$emit("search", {});
    }
  }
};
</script>
